module.exports = __webpack_public_path__ + "static/media/YEL.e2411865.svg";